import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 90vh;
`

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 40px;
  padding-bottom: 1%;
  background-color: #eff3fa;
`

interface IRow {
  width?: string
  margin?: string
  justifyContent?: string
  alignItems?: string
}

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: ${(props: IRow) => props.alignItems || 'center'};
  justify-content: ${(props: IRow) => props.justifyContent || 'flex-start'};
  gap: 16px;
  margin-top: 10px 0px;
  width: ${(props: IRow) => props.width || '100%'};
  margin: ${(props: IRow) => props.margin || '0px'};
`

export const Badge = styled.div`
  position: absolute;
  top: -20px;
  right: -10px;
  background-color: #9ed47d;
  color: #484848;
  font-size: 14px;
  font-weight: 500;
  padding: 6px 12px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 6px;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`

export const SparkleIcon = styled.img`
  width: 20px;
  height: 20px;
`

export const CardWithBadgeContainer = styled.div`
  position: relative;
`
